import { render, staticRenderFns } from "./technicalSupport.vue?vue&type=template&id=b0b63378&scoped=true&"
import script from "./technicalSupport.vue?vue&type=script&lang=js&"
export * from "./technicalSupport.vue?vue&type=script&lang=js&"
import style0 from "./technicalSupport.vue?vue&type=style&index=0&id=b0b63378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b63378",
  null
  
)

export default component.exports